import { useEffect, useState } from 'react';

/** Refresh calendar gates at local midnight and after returning to the app. */
export function useLocalDayClock(): number {
  const [now, setNow] = useState(Date.now);
  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;
    const schedule = () => {
      clearTimeout(timeout);
      const current = new Date();
      const next = new Date(current.getFullYear(), current.getMonth(), current.getDate() + 1);
      timeout = setTimeout(refresh, Math.max(1, next.getTime() - current.getTime()));
    };
    const refresh = () => {
      setNow(Date.now());
      schedule();
    };
    const onVisibility = () => { if (!document.hidden) refresh(); };
    schedule();
    window.addEventListener('focus', refresh);
    document.addEventListener('resume', refresh);
    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      clearTimeout(timeout);
      window.removeEventListener('focus', refresh);
      document.removeEventListener('resume', refresh);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, []);
  return now;
}
